export const MuiCircularProgress = {
  styleOverrides: {
    root: {
      color: '#fff',
    },
  },
}
